import React, { ReactElement, useRef } from 'react';

import { ElectricScooterDetails } from 'Api/insurance';
import { CancelForm } from 'Forms/CancelFormV2/CancelForm';

import { WrapMdMarginBottom } from 'App/global-style';
import { getAppText } from 'Utils/text';
import { getElectricScooterCancellationValidationSchema } from './cancelElectricScooterForm.validation';
import { CancelElectricScooterFormFields } from './components/CancelElectricScooterFormFields';
import { mapInitialValuesElectricScooterCancellation } from './mappers/mapInitialValuesElectricScooterCancellation';

interface CancelElectricScooterFormProps {
  insurance: ElectricScooterDetails;
}

export const CancelElectricScooterForm = ({
  insurance,
}: CancelElectricScooterFormProps): ReactElement => {
  const alertRef = useRef<HTMLDivElement>(null);
  const initialValues = mapInitialValuesElectricScooterCancellation();

  return (
    <CancelForm
      insurance={insurance}
      initialValues={initialValues}
      validationSchema={getElectricScooterCancellationValidationSchema()}
      alertRef={alertRef}
    >
      <>
        <WrapMdMarginBottom>
          <p>{getAppText('cancel.electricScooter.ingress')}</p>
        </WrapMdMarginBottom>
        <CancelElectricScooterFormFields insurance={insurance} />
      </>
    </CancelForm>
  );
};
